import React, { useState } from 'react';
import { X, Lock, ShieldCheck, AlertCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useStore } from '../../context/StoreContext';

const AdminLoginModal = ({ isOpen, onClose, onSuccess }) => {
  const { lang, t } = useLanguage();
  const { loginAdmin } = useStore();
  const [pin, setPin] = useState('');
  const [error, setError] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = loginAdmin(pin);
    if (success) {
      setError(false);
      setPin('');
      onSuccess();
    } else {
      setError(true);
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
      <div 
        className="relative bg-white w-full max-w-sm rounded-3xl shadow-2xl p-6 border border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 left-4 p-1.5 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-700"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center space-y-3 mb-6">
          <div className="w-14 h-14 bg-pansar-100 text-pansar-800 rounded-2xl flex items-center justify-center mx-auto shadow-inner">
            <Lock className="w-7 h-7" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900 font-urdu">
              ایڈمن لاگ ان
            </h3>
            <p className="text-xs text-gray-500 font-urdu mt-1">
              پنسار سٹور مینجمنٹ اور آرڈرز کنٹرول پینل
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-700 font-urdu mb-1.5">
              سیکیورٹی پاس کوڈ / پن درج کریں:
            </label>
            <input
              type="password"
              autoFocus
              maxLength={8}
              value={pin}
              onChange={(e) => {
                setPin(e.target.value);
                setError(false);
              }}
              placeholder="ڈیفالٹ پن: 1234"
              className={`w-full p-3 rounded-xl border text-center text-lg tracking-widest font-mono ${
                error ? 'border-rose-400 bg-rose-50' : 'border-gray-200 focus:border-pansar-700'
              } focus:outline-none`}
            />
            {error && (
              <p className="text-xs text-rose-600 font-urdu mt-1 text-center flex items-center justify-center gap-1">
                <AlertCircle className="w-3.5 h-3.5" />
                <span>غلط پن کوڈ! دوبارہ کوشش کریں (ڈیفالٹ: 1234)۔</span>
              </p>
            )}
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-pansar-800 hover:bg-pansar-900 text-white font-bold text-xs font-urdu shadow-md transition"
          >
            ڈیش بورڈ میں داخل ہوں
          </button>

          <p className="text-[11px] text-gray-400 text-center font-urdu">
            پاس کوڈ ایڈمن سیٹنگز سے کسی بھی وقت تبدیل کیا جا سکتا ہے۔
          </p>
        </form>

      </div>
    </div>
  );
};

export default AdminLoginModal;
